import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';
import { Paragraph, ParagraphProps } from '../Paragraph';

export const StyledSalesMessage = styled(Paragraph)`
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.dStyles.elements.salesMessage,
    )}
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements.salesMessage,
    )}
`;

export type SalesMessageProps = ParagraphProps;

export const SalesMessage = ({ text }: SalesMessageProps) => (
  <StyledSalesMessage text={text} />
);
